let userCode = [
  { name: "首页", code: "home", path: "/home" },
  { name: "区域库", code: "qyk", path: "/arealibrary" },
  { name: "区域审核", code: "qysh", path: "/regReview" },
  { name: "行业管理", code: "hygl", path: "/Industry" },
  { name: "实名信息", code: "smxx", path: "/realName" },
  { name: "权限管理", code: "jsgl", path: "/role" },
  { name: "操作日志", code: "czrz", path: "/operationLog" },
];
export default userCode;
